<template>
   <div class="profil">
      <!-- main-area -->
      <main class="fix">
         <!-- breadcrumb-area -->
         <section class="breadcrumb__area breadcrumb__bg">
            <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100"
               :style="{ backgroundImage: `url('assets/img/banner/banner1.png')` }"></div>
            <div class="container">
               <div class="row">
                  <div class="col-lg-6">
                     <div class="breadcrumb__content">
                        <h2 class="title">RPJMD</h2>
                        <nav aria-label="breadcrumb">
                           <ol class="breadcrumb">
                              <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                              <li class="breadcrumb-item active" aria-current="page">RPJMD</li>
                           </ol>
                        </nav>
                     </div>
                  </div>
               </div>
            </div>
            <div class="breadcrumb__shape">
               <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
               <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
               <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
               <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
               <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
            </div>
         </section>
         <!-- breadcrumb-area-end -->
         <!-- about-area -->
         <section class="about__area-eight home-9">
            <div class="container">
               <div class="row pb-40">
                  <div class="blog-post-wrap">
                     <div class="sidebar__widget sidebar__widget-two">
                        <div class="sidebar__search">
                           <form action="#">
                              <input type="text" v-model="cari_value" @keyup="cari_data()" placeholder="Cari Data" />
                              <button type="button" style="cursor: default;">
                                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                    <path
                                       d="M19.0002 19.0002L14.6572 14.6572M14.6572 14.6572C15.4001 13.9143 15.9894 13.0324 16.3914 12.0618C16.7935 11.0911 17.0004 10.0508 17.0004 9.00021C17.0004 7.9496 16.7935 6.90929 16.3914 5.93866C15.9894 4.96803 15.4001 4.08609 14.6572 3.34321C13.9143 2.60032 13.0324 2.01103 12.0618 1.60898C11.0911 1.20693 10.0508 1 9.00021 1C7.9496 1 6.90929 1.20693 5.93866 1.60898C4.96803 2.01103 4.08609 2.60032 3.34321 3.34321C1.84288 4.84354 1 6.87842 1 9.00021C1 11.122 1.84288 13.1569 3.34321 14.6572C4.84354 16.1575 6.87842 17.0004 9.00021 17.0004C11.122 17.0004 13.1569 16.1575 14.6572 14.6572Z"
                                       stroke="currentcolor" stroke-width="2" stroke-linecap="round"
                                       stroke-linejoin="round" />
                                 </svg>
                              </button>
                           </form>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="row align-items-center justify-content-center" style="padding: 0 15px;">
                  <div class="about__content-seven">
                     <div class="choose__box-wrap home-9-two mb-5">
                        <div class="row">
                           <div v-for="data in list_data" :key="data.id"
                              class="choose__box choose__box-home-9 bg-white border rounded-3 p-4 mb-2 justify-content-between">
                              <div class="content">
                                 <h4 class="title">{{ data.judul }}</h4>
                                 <span class="sub-title" v-html="data.kategori"></span><br>
                                 <span style="color: #F7A400; font-weight: 400;"><i class="fas fa-calendar-alt"></i>
                                    {{ convert_tgl(data.createAt) }}</span>
                              </div>
                              <div>
                                 <a class="icon" href="javascript:void(0);" @click.prevent="selectData(data)"
                                    data-bs-toggle="modal" data-bs-target="#modalFoto" data-bs-tooltip="tooltip"
                                    title="Download File">
                                    <i class="fas fa-file-download"></i>
                                 </a>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="pagination-wrap mt-40">
               <nav aria-label="Page navigation example">
                  <ul class="pagination list-wrap">
                     <!-- Prev -->
                     <li class="page-item" :class="{ disabled: page_first === 1 }"><a class="page-link"
                           href="javascript:void(0);" @click="btn_prev"><i class="fas fa-angle-double-left"></i></a>
                     </li>

                     <!-- Loop halaman -->
                     <li v-for="page in pagesToShow" :key="'page_' + page" class="page-item"
                        :class="{ active: page === page_first, disabled: page === '...' }">
                        <a v-if="page !== '...'" class="page-link" href="javascript:void(0);" @click="goToPage(page)">
                           {{ page }}
                        </a>
                        <span v-else class="page-link">...</span>
                     </li>

                     <!-- Next -->
                     <li class="page-item" :class="{ disabled: page_first === page_last }"><a class="page-link"
                           href="javascript:void(0);" @click="btn_next"><i class="fas fa-angle-double-right"></i></a>
                     </li>
                  </ul>
               </nav>
            </div>
         </section>
         <!-- about-area-end -->
      </main>
      <!-- main-area-end -->
      <div id="modalFoto" class="modal fade" tabindex="-1">
         <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
               <div class="modal-header">
                  <h6 class="modal-title">{{ form.judul }}</h6>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
               </div>
               <div class="modal-body">
                  <iframe :src="file_path + form.file" width="100%" height="800px"></iframe>
               </div>
               <div class="modal-footer">
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import UMUM from '../../library/umum'

export default {

   data() {
      return {
         file_path: this.$store.state.url.URL_APP + "uploads/",
         cek_load_data: true,
         form: {
            id: '',
            judul: '',
            deskripsi: '',
            file: '',
            unit_kerja: '',
         },
         list_data: [],
         page_first: 1,
         page_last: 0,
         max_visible: 5,
         cari_value: "",
         UMUM: UMUM,
         kategori: "RPJMD",
      }
   },

   methods: {
      getView: function () {
         fetch(this.$store.state.url.URL_DOKUMEN + "view", {
            method: "POST",
            headers: {
               "content-type": "application/json",
            },
            body: JSON.stringify({
               data_ke: this.page_first,
               cari_value: this.cari_value,
               kategori: this.kategori
            })
         })
            .then(res => res.json())
            .then(res_data => {
               this.list_data = res_data.data;
               this.page_last = res_data.jml_data;
            });
      },

      selectData: function (data) {
         this.form = {
            id: data.id,
            judul: data.judul,
            deskripsi: data.deskripsi,
            file: data.file,
         };
      },
      convert_tgl: function (dateString) {
         var date = new Date(dateString);
         var getBulan = date.getMonth() + 1; var bulan = '';
         if (getBulan == '1') { bulan = 'Jan' }
         else if (getBulan == '2') { bulan = 'Feb' }
         else if (getBulan == '3') { bulan = 'Mar' }
         else if (getBulan == '4') { bulan = 'Apr' }
         else if (getBulan == '5') { bulan = 'Mei' }
         else if (getBulan == '6') { bulan = 'Jun' }
         else if (getBulan == '7') { bulan = 'Jul' }
         else if (getBulan == '8') { bulan = 'Agt' }
         else if (getBulan == '9') { bulan = 'Sep' }
         else if (getBulan == '10') { bulan = 'Okt' }
         else if (getBulan == '11') { bulan = 'Nov' }
         else if (getBulan == '12') { bulan = 'Des' }
         return date.getDate() + " " + bulan + " " + date.getFullYear();
      },
      btn_prev: function () {
         this.cek_load_data = true;
         if (this.page_first > 1) {
            this.page_first--
         } else {
            this.page_first = 1;
         }
         this.getView();
      },

      btn_next: function () {
         if (this.page_first >= this.page_last) {
            this.page_first == this.page_last
         } else {
            this.page_first++;
         }
         this.getView();
      },

      goToPage(page) {
         if (page === '...') return;
         this.page_first = page;
         this.getView();
      },

      cari_data: function () {
         this.page_first = 1;
         this.getView();
      },
   },

   computed: {
      pagesToShow() {
         const pages = [];
         const total = this.page_last;
         const current = this.page_first;
         const max = this.max_visible;

         if (total <= max) {
            for (let i = 1; i <= total; i++) pages.push(i);
         } else {
            pages.push(1);

            if (current > 3) pages.push("...");

            const start = Math.max(2, current - 1);
            const end = Math.min(total - 1, current + 1);

            for (let i = start; i <= end; i++) pages.push(i);

            if (current < total - 2) pages.push("...");

            pages.push(total);
         }

         return pages;
      },
   },

   mounted() {
      this.getView();
   }
}
</script>
